import { Box, Container, Grid, Theme, useTheme } from '@mui/material'
import { makeStyles } from "@mui/styles"
import { FC, RefObject } from 'react'
import { Animated } from "react-animated-css"
import { Parallax } from 'react-scroll-parallax'
import { useWindowSize } from 'react-use'
import HeroSectionImg1 from '../../../assets/images/hero-section/1.png'
import HeroSectionImg2 from '../../../assets/images/hero-section/2.png'
import HeroSectionImg3 from '../../../assets/images/hero-section/3.png'
import HeroSectionImg4 from '../../../assets/images/hero-section/4.png'
import { images } from '../../../constants/assets'
import AppButton from '../../common/Button/AppButton'
import Text from '../../common/Text'
import ReactPlayer from 'react-player'
import HeroVideoBg from '../../../assets/hero_videodemo.mp4'
const useStyles = makeStyles((theme: Theme) => ({
    root: {
        backgroundColor: theme.palette.custom.base,
        padding: theme.spacing(16, 0),
        position: 'relative',
        overflowX: 'hidden',
        overflowY: 'hidden',

        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(4, 0),
        }
    },
    heroTitle: {
        fontSize: 72,
        fontWeight: 700,
        lineHeight: '96px',
        marginBottom: theme.spacing(2),

        '& .highlight': {
            background: 'linear-gradient(to right, #FF5223 0%, #FF1D92 100%)',
            '-webkit-background-clip': 'text',
            '-webkit-text-fill-color': 'transparent',
            position: 'relative'
        },

        [theme.breakpoints.down('md')]: {
            fontSize: 32,
            lineHeight: '48px',
        }
    },
    heroSubtitle: {
        fontSize: 26,
        lineHeight: '44px',
        marginBottom: theme.spacing(8.5),

        [theme.breakpoints.down('md')]: {
            fontSize: 16,
            lineHeight: '30px',
            marginBottom: theme.spacing(7.5),
        }
    },
    leftGlow: {
        position: 'absolute',
        top: 0,
        left: 0,
        transform: 'translateX(-50%)',
        opacity: 0.25
    },
    rightGlow: {
        position: 'absolute',
        top: 0,
        right: 0,
        transform: 'translate(50%, 50%)',
        opacity: 0.35
    },
    gridImagesArea: {
        marginTop: theme.spacing(17),
        position: 'relative',

        '& img': {
            maxWidth: '100%',
            height: 'auto'
        },

        [theme.breakpoints.down('md')]: {
            marginTop: theme.spacing(12),
        }
    },
    heroSecImg1Col: {

    },
    heroSecImg2Col: {
        position: 'relative',
        top: 0,
        transform: 'translateY(-20%)'
    },
    heroSecImg3Col: {

    },
    heroSecImg4Col: {
        position: 'relative',
        top: 0,
        transform: 'translateY(-35%)',

        [theme.breakpoints.down('md')]: {
            display: 'none'
        }
    },
    sparkGroup1: {
        position: 'absolute',
        left: 0,
        top: 0,
        transform: 'translate(-40%, -30%)'
    },
    sparkGroup2: {
        position: 'absolute',
        right: 0,
        top: 0,
        transform: 'translate(250%, -100%)',

        [theme.breakpoints.down('md')]: {
            display: 'none'
        }
    },
    // new_hero_banner_wrapper:{
    //     position: 'absolute',
    //     width: 100 + '%',
    //     overflow: 'hidden',
    //     height: 100 + 'vh',
    //     // paddingTop: 56.25 + '%'
    //     top: 0,
    //     left: 0
    // },
    responsive_video_frame:{
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        width: 100 + '%',
        height: 100 + '%',
        border: 'none'
    }
    
}))

interface Props {
    innerRef: RefObject<HTMLElement>
}


const HeroSection: FC<Props> = ({
    innerRef
}) => {
    const classes = useStyles()
    const { width } = useWindowSize()
    const theme = useTheme()

    return (
        // <Box ref={innerRef} className={classes.root} component='section' id='home'>
        //     <Container>
        //         <Animated animationIn="fadeInDown" animationOut="fadeInUp" isVisible animationInDelay={200}>
        //             <Text className={classes.heroTitle}>
        //                 <span className='highlight'>
        //                     <img className={classes.sparkGroup1} src={images.SparkGroup1} alt='spark-left' />
        //                     Hook your audience{' '}
        //                     <img className={classes.sparkGroup2} src={images.SparkGroup2} alt='spark-right' />
        //                 </span>with
        //                 seamless video experience
        //             </Text>
        //         </Animated>
        //         <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible animationInDelay={800}>
        //             <Text className={classes.heroSubtitle}>
        //                 Your ultimate on demand production partner offers all of your needed production services stitched with most elevated platform and stinging approach. <br /> Be a part of a whole new world of infotainment and entertainment with The Proreal OTT.
        //             </Text>
        //             <a href='https://www.ottproreal.com/'>
        //                 <AppButton variant='contained'>Watch now</AppButton>
        //             </a>
        //         </Animated>
        //         <Grid container columnSpacing={width < theme.breakpoints.values.sm ? 1 : 4} className={classes.gridImagesArea}>
        //             <Grid item xs={4} md={3} className={classes.heroSecImg1Col}>
        //                 <Animated animationIn="fadeInUp" animationOut="fadeInDown" isVisible animationInDelay={500}>
        //                     <Parallax translateY={[0, -50]}>
        //                         <img src={HeroSectionImg1} alt='1' />
        //                     </Parallax>
        //                 </Animated>
        //             </Grid>
        //             <Grid item xs={4} md={3} className={classes.heroSecImg2Col}>
        //                 <Animated animationIn="fadeInUp" animationOut="fadeInDown" isVisible animationInDelay={1000}>
        //                     <Parallax translateY={['-10%', '30%']}>
        //                         <img src={HeroSectionImg2} alt='2' />
        //                     </Parallax>
        //                 </Animated>
        //             </Grid>
        //             <Grid item xs={4} md={3} className={classes.heroSecImg3Col}>
        //                 <Animated animationIn="fadeInUp" animationOut="fadeInDown" isVisible animationInDelay={1500}>
        //                     <Parallax translateY={['0%', '-70%']}>
        //                         <img src={HeroSectionImg3} alt='3' />
        //                     </Parallax>
        //                 </Animated>
        //             </Grid>
        //             <Grid item xs={4} md={3} className={classes.heroSecImg4Col}>
        //                 <Animated animationIn="fadeInUp" animationOut="fadeInDown" isVisible animationInDelay={2000}>
        //                     <Parallax translateY={[0, 40]}>
        //                         <img src={HeroSectionImg4} alt='4' />
        //                     </Parallax>
        //                 </Animated>
        //             </Grid>
        //         </Grid>
        //     </Container>
        //     <img className={classes.leftGlow} src={images.RadialGlow} alt='left glow' />
        //     <img className={classes.rightGlow} src={images.RadialGlow} alt='right glow' />
        // </Box>
        <>
            <div className={`new_hero_banner_wrapper`}>
                {/* <ReactPlayer
                    className='responsive_video_frame'
                    url= 'https://www.youtube.com/embed/h7VlRY1651g??modestbranding=0&autoplay=1&mute=1'
                    controls = {false}
                    frameBorder='0'
                    allow="accelerometer; autoplay=1"
                    allowFullScreen
                    title='video'

                /> */}
                {/* <iframe className={classes.responsive_video_frame} src="https://www.youtube.com/embed/tgbNymZ7vqY"></iframe> */}
                {/* <iframe src="https://www.youtube-nocookie.com/embed/h7VlRY1651g" title="YouTube video player" allow="accelerometer;?autoplay=1; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe> */}
                <video autoPlay muted loop className="hero_video_bg">
                    <source src={HeroVideoBg} type="video/mp4" />
                </video>
                {/* <ReactPlayer
                    className='hero_video_bg'
                    url= {HeroVideoBg}
                    autoPlay={true}
                    muted
                    loop

                /> */}
               
            </div>
        </>
    )
}

export default HeroSection